import { groq } from 'next-sanity'

export const COLOR_PROJECTION = groq`{
    hex,
    alpha,
    hsl{h, s, l, a}
  }`
